import { GraphQLQueryClass } from "@bsm/component";
import { TSignatory } from "@bsm/graphql";

export default class InvoiceSignatoryDetailsQuery
    implements GraphQLQueryClass<TSignatory, TResponse>
{
    queryKey = "Invoice.Signatory.Details.Query";

    gql = `
        query InvoiceSignatoryDetails($id: Float) {
            signatory(filter: { id: $id }) {
                id
                name
                fonction
                signature { id }
            }
        }
    `;

    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TSignatory {
        return data.signatory;
    }
}

type TResponse = {
    signatory: TSignatory;
}